"use strict";

angular.module("core")
.controller("ZebraPrinterSelectModal", function($scope, $attrs, close) {
    $scope.printers = $attrs.printers;
    $scope.title = $attrs.title;
    $scope.message = $attrs.message;
    $scope.context = $attrs.context;

    $scope.selectedPrinter = $attrs.selectedPrinter;

    this.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();

        close.apply(this, arguments);
    };
})



//////////////////
// WEBPACK FOOTER
// ./core/zebra-printer/zebra-printer-select.modal.js
// module id = 666
// module chunks = 0